import React from 'react';
import { Box } from '@mui/material';

/**
 * Plan Central — documentation. The handbook is a self-contained static page
 * (public/plan-central-docs.html) so it keeps its own editorial design in both
 * UI shells; this page frames it full-height. Reached from the Documentation
 * button on Plan Central (no drawer entry).
 */
const PlanCentralDocs = () => (
	<Box sx={{ height: 'calc(100vh - 112px)', minHeight: 480 }}>
		<Box
			component="iframe"
			src="/plan-central-docs.html"
			title="The Plan Builder Handbook"
			sx={{ border: 0, width: '100%', height: '100%', display: 'block', bgcolor: '#fff' }}
		/>
	</Box>
);

export default PlanCentralDocs;
